import React from "react"

import InvestorDashboard from "./investorDashboard"
import { useSelector } from "react-redux"
import AdminDashboard from "./AdminDashboard"
import WealthPartnerDashboard from "./WealthPartnerDashboard"

const Dashboard = () => {
  document.title = "Dashboard | Prachay"

  const { userType } = useSelector((state) => state.user)

  return (
    <React.Fragment>
      <div className={userType === "ADMIN" ? "" : "page-content"}>
        {userType === "ADMIN" && <AdminDashboard />}
        {userType === "INVESTOR" && <InvestorDashboard />}
        {userType === "WEALTH_PARTNER" && <WealthPartnerDashboard />}
      </div>
    </React.Fragment>
  )
}

export default Dashboard
